import { memo } from "react";
import { MessageSquare, CheckCircle, Wrench, ShieldCheck } from "lucide-react";
import { useScrollReveal } from "@/hooks/useAnimations";

const STEPS = [
  { num: 1, Icon: MessageSquare, title: "Diagnostic", desc: "Gratuit et immédiat", delay: "0.1s", glow: true },
  { num: 2, Icon: CheckCircle, title: "Devis", desc: "Transparent et sans engagement", delay: "0.2s" },
  { num: 3, Icon: Wrench, title: "Réparation", desc: "Rapide et soignée", delay: "0.3s" },
  { num: 4, Icon: ShieldCheck, title: "Garantie", desc: "6 mois sur pièces et main d'œuvre", delay: "0.4s" },
];

export const ProcessSection = memo(() => {
  const [processRef, processVisible] = useScrollReveal(0.1);

  return (
    <section className="section-padding bg-slate-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Comment ça marche ?</h2>
          <p className="text-lg text-slate-600">Un processus simple et transparent pour votre réparation</p>
        </div>

        <div
          ref={processRef}
          className={`grid md:grid-cols-4 gap-8 transition-all duration-1000 ${processVisible ? "opacity-100" : "opacity-0"}`}
        >
          {STEPS.map((step) => {
            const { Icon } = step;
            return (
              <div key={step.num} className="relative process-step text-center" style={{ transitionDelay: step.delay }}>
                <div className={`w-16 h-16 mx-auto rounded-full bg-red-600 text-white flex items-center justify-center mb-4 relative z-10 ${step.glow ? "pulse-glow" : ""}`}>
                  <Icon className="h-7 w-7" />
                </div>
                <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-2 text-xs font-bold text-red-600 bg-red-100 px-2 py-0.5 rounded-full">
                  {step.num}
                </span>
                <h3 className="font-semibold text-lg text-slate-900 mb-1">{step.title}</h3>
                <p className="text-slate-600 text-sm">{step.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
});

ProcessSection.displayName = "ProcessSection";
